@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-brands/glass-house-price/glass-house-brands-price.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  display: contents;
}
:host .pricing-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.1875rem;
}
:host .pricing-container .price-line-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 0.125rem;
  justify-content: flex-start;
  align-items: flex-start;
}
:host .pricing-container .price-line-item .glass-house-pricing-header {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-family: inter, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 0.5rem;
  line-height: 100%;
  letter-spacing: 0.64px;
}
:host .pricing-container .price-line-item .glass-house-pricing-header div {
  padding-left: 1.8rem;
  line-height: 99%;
}
:host .pricing-container .price-line-item .glass-house-price {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
:host .pricing-container .price-line-item .pre-tax {
  opacity: 0.38;
}
:host ::ng-deep .product-variant-price {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: normal;
  display: flex;
  flex-direction: row-reverse;
  gap: 0.25rem;
  justify-content: space-between;
  align-items: center;
  gap: 0.25rem;
  width: unset;
  overflow: visible;
}
:host ::ng-deep .product-variant-price .product-variant-current-price,
:host ::ng-deep .product-variant-price .product-variant-previous-price {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
:host ::ng-deep .product-variant-price .product-variant-previous-price {
  font-size: 0.8125rem;
  letter-spacing: -0.25px;
  text-decoration: unset;
  text-align: left;
}
:host ::ng-deep .product-variant-price .product-variant-current-price {
  font-size: 0.8125rem;
  letter-spacing: -0.25px;
}
:host ::ng-deep .product-variant-price .leading-text-current-price {
  font-size: 0.4rem;
  line-height: 150%;
}
:host ::ng-deep .product-variant-price .product-variant-price-decoration {
  font-size: 0.4rem;
  line-height: 150%;
  padding-left: 0.05rem;
}
:host ::ng-deep .force-italic-style * {
  font-family: inter, sans-serif;
  font-weight: 700;
  font-style: italic;
}
:host ::ng-deep .force-bold-style * {
  font-family: inter, sans-serif;
  font-weight: 900;
  font-style: normal;
}
/*# sourceMappingURL=glass-house-brands-price.component.css.map */
